import { KYMW0600OutputModel } from './vo/kymw0600-output.model';
import { KYMW0600InputModel } from './vo/kymw0600-input.model';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, ComponentRef, ViewContainerRef } from '@angular/core';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0600Model } from './kymw0600.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { CellRange, CellType, FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';
import { UpdateRelationPcodeService } from './api-services/update_relation_pcode.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { GetTargetRelationPcodeGoodsInfoService } from './api-services/get_target_relation_pcode_goods_info.service';
import { KYMW0300InputModel } from '../../kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0300Component } from '../../kymw03/kymw0300/kymw0300.component';
import { KYMW0300OutputModel } from '../../kymw03/kymw0300/vo/kymw0300-output.model';
import { GetCandidateListInfoService } from './api-services/get_candidate_list_info.service';
import { PlessViewUtils } from 'src/app/shared/utils/pless-view-utils.service';
import { KYMW0300Model } from '../../kymw03/kymw0300/kymw0300.model';

/**
 * 関連商品設定画面を管理するクラス
 *
 * @export KYMW0600Component
 * @class KYMW0600Component
 */
@Component({
  selector: 'app-kymw0600',
  templateUrl: 'kymw0600.component.html',
  styleUrls: ['kymw0600.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW0600Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw0600Model: KYMW0600Model = new KYMW0600Model();

  @ViewChild('txti_pCode', { static: true }) txti_pCode: ElementRef;
  @ViewChild('dg_relatedInfo', { static: true }) dg_relatedInfo: FlexGrid;
  @ViewChild('dg_candidateInfo', { static: true }) dg_candidateInfo: FlexGrid;

  public setKYMW0600Parameter: Function;

  /**
    * 画面受渡情報
    * 画面呼び出し時に受け渡されるオブジェクト
    */
  public inputVO: KYMW0600InputModel;

  public kymw0300ComponentRef: ComponentRef<any> = null;

  public kymw0300Component: KYMW0300Component;

  // 商品検索画面のVO
  private kymw0300InputVO: KYMW0300InputModel = null;
  
  public kymw0300Model: KYMW0300Model = new KYMW0300Model();

  // 関連商品一覧contextmenu
  relatedGoodsContextmenu: Menu;

  // 候補一覧contextmenu
  candidateGoodsContextmenu: Menu;

  // 編集フラグ
  private editFlag = false;

  /**
   *Creates an instance of KYMW0600Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0600Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private updateRelationPcodeService: UpdateRelationPcodeService,
    private getTargetRelationPcodeGoodsInfoService: GetTargetRelationPcodeGoodsInfoService,
    private getCandidateListInfoService: GetCandidateListInfoService,
    private viewContainerRef: ViewContainerRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0600Component
   */
  public ngOnInit(): void {
    this.kymw0600Model.kymw0600Component = this;
    this.componentName = 'KYMW0600';
    this.dg_relatedInfo.selectionMode = SelectionMode.Row;
    this.dg_relatedInfo.itemsSourceChanged.addHandler(() => {
      // 行の選択解除
      this.dg_relatedInfo.select(-1, -1);

      // 背景色設定処理
      this.setColorPattern();
    });

    this.dg_candidateInfo.selectionMode = SelectionMode.Row;
    this.dg_candidateInfo.itemsSourceChanged.addHandler(() => {
      // 行の選択解除
      this.dg_candidateInfo.select(-1, -1);
    });

    // コンテキストメニュー作成
    this.createContextMenu();

    // 受け渡されたPコードをもとに、関連商品情報を取得するための要求をサーバ側へ送信する
    this.getTargetRelationPcodeGoodsInfoService.execute(this.kymw0600Model, this.inputVO.pCode);
  }

  /**
   * データグリッド行の背景色設定
   */
  public setColorPattern(): void {
    if (this.dg_relatedInfo.rows.length > 0) {
      this.kymw0600Model.relatedGoodsList.forEach((element, ind) => {
        if (ind == 2 && !PlessViewUtils.isEmpty(element.applyTermEnd)) {
          const today = new Date();
          const year = today.getFullYear();
          const month = String(today.getMonth()).padStart(2, "0");
          const day = String(today.getDate()).padStart(2, "0");

          const convertToday = new Date(year, Number(month), Number(day));

          const applyTermEnd = element.applyTermEnd;
          const endYear = parseInt(applyTermEnd.substring(0, 4), 10);
          const endMonth = parseInt(applyTermEnd.substring(4, 6), 10) -1;
          const endDay = parseInt(applyTermEnd.substring(6, 8), 10);

          const convertApplyTermEnd = new Date(endYear, endMonth, endDay);

          if (convertToday > convertApplyTermEnd) {
              this.dg_relatedInfo.rows[ind].cssClass = 'grid-row-term-end';
          } else {
            this.dg_relatedInfo.rows[ind].cssClass = 'grid-row-normal';
          }
        } else if (ind != 1) {
          this.dg_relatedInfo.rows[ind].cssClass = 'grid-row-normal';
        }
      });
    }
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0600Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = <KYMW0600InputModel>param;
  }

  /**
   * 関連商品設定のCairngormイベントを発生させるメソッド
   * 複数箇所から呼び出されるため、メソッド化している
   *
   */
  public saveEventDispatch(): void {
    // Cairngormイベントを発生させる
    this.updateRelationPcodeService.execute(this.kymw0600Model, () => {
      this.editFlag = false;
      this.closeFunction();
    });
  }

  /**
   * 商品検索ボタン押下時の処理
   * @returns 
   */
  public eventSeach_CLICKHandler() {
    const componentRef = this.dialogService.openModal(KYMW0300Component);
    const instance = componentRef.componentInstance as KYMW0300Component;
    instance.parent = this;
    if (this.kymw0300InputVO === null) {
      this.kymw0300InputVO = new KYMW0300InputModel();
    }
    // 企画関連条件を表示しない（企画検索フラグ:0）
    this.kymw0300InputVO.catalogSearchFlg = 0;

    instance.setInterfaceParam(this.kymw0300InputVO);
    instance.setKYMW0300Parameter =
          (outputVO: KYMW0300OutputModel) => {
            // 検索条件を保持
            this.kymw0300InputVO = this.kymw0300Model.getKYMW0300SearchHistory(outputVO);
            this.getCandidateListInfoService.execute(this.kymw0600Model, outputVO);
          };
    instance.closeFunction = () => {
      componentRef.close();
    };
    return instance;

  }

  /**
   * 関連商品一覧のデータグリッドで、「クリア」が選択された際のイベントハンドラ
   */
  public eventDgRelatedInfoClear_CLICKHandler(): void {
    this.editFlag = true;

    // データグリッドの選択されている行位置を取得
    const selectedIndex: number = this.dg_relatedInfo.selection.row;

    // 各情報をブランクに変更
    this.kymw0600Model.relatedGoodsList[selectedIndex].pCode = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].goodsName = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].guideStandardName = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].makerName = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].payeeClientCode = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].supplierNameKanji = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].displaySupplier = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].regularRegistDate = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].relationPcodeOld = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].relationPcodeNew = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].groupId = "";
    this.kymw0600Model.relatedGoodsList[selectedIndex].applyTermEnd = "";

    this.setColorPattern();
    this.dg_relatedInfo.refresh();
    this.kymw0600Model.enabledUpdate = false;
  }

  /**
   * 候補一覧のデータグリッドで、「新商品に設定」「旧商品に設定」が選択された際のイベントハンドラ
   * @param mode 0: 新商品、2: 旧商品
   */
  public eventDgCandidateInfoGoodsSetup_CLICKHandler(mode: number): void {
    // データグリッドの選択されている行情報を取得
    const selectItem = this.dg_candidateInfo.selectedItems[0];

    // 関連商品一覧重複チェック
    for (const e of this.kymw0600Model.relatedGoodsList) {
      if (e.pCode == selectItem.pCode) {
        this.dialogService.openAlertGetMessage('E0115', ["関連商品"]);
        return;
      }
    }

    // 設定済みの場合は上書き確認
    if (this.kymw0600Model.relatedGoodsList[mode].pCode) {
      this.dialogService.openAlertGetMessage('Q0197', [], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.setRelatedGoodsList(mode, selectItem);
        }
      });
    } else {
      this.setRelatedGoodsList(mode, selectItem);
    }
  }

  /**
   * 関連商品一覧に値を設定
   */
  private setRelatedGoodsList(mode: number, selectItem: any): void {
    this.editFlag = true;
    this.kymw0600Model.relatedGoodsList[mode].pCode = selectItem.pCode;
    this.kymw0600Model.relatedGoodsList[mode].goodsName = selectItem.goodsName;
    this.kymw0600Model.relatedGoodsList[mode].guideStandardName = selectItem.guideStandardName;
    this.kymw0600Model.relatedGoodsList[mode].makerName = selectItem.makerName;
    this.kymw0600Model.relatedGoodsList[mode].payeeClientCode = selectItem.payeeClientCode;
    this.kymw0600Model.relatedGoodsList[mode].supplierNameKanji = selectItem.supplierNameKanji;
    this.kymw0600Model.relatedGoodsList[mode].displaySupplier = selectItem.displaySupplier;
    this.kymw0600Model.relatedGoodsList[mode].regularRegistDate = selectItem.regularRegistDate;
    this.kymw0600Model.relatedGoodsList[mode].relationPcodeOld = selectItem.relationPcodeOld;
    this.kymw0600Model.relatedGoodsList[mode].relationPcodeNew = selectItem.relationPcodeNew;
    this.kymw0600Model.relatedGoodsList[mode].groupId = selectItem.groupId;
    this.kymw0600Model.relatedGoodsList[mode].applyTermEnd = selectItem.applyTermEnd;
    this.kymw0600Model.enabledUpdate = false;
    this.setColorPattern();
    this.dg_relatedInfo.refresh();
  }

  /**
   * 更新ボタン押下時の処理
   * @param event コールバック・イベントへの参照
   *
   */
  public eventBtnUpdate_CLICKHandler(event: MouseEvent): void {
    // 関連チェック
    let checkGroupIdNum: number = <number>-1;

    // DataGridに全データをチェックし、-1(初期値)より大きいグループIDが存在するか確認する
    for (const tempVO of this.kymw0600Model.relatedGoodsList) {
      // 存在する場合は、グループIDを設定し、ループを抜ける
      if (tempVO.groupId >= 0) {
        checkGroupIdNum = tempVO.groupId;
        break;
      }
    }

    // グループIDが既に設定されているデータで「設定」ボタンが押下された際、
    // 他のグループIDのデータを関連設定していないか確認する
    if (checkGroupIdNum >= 0) {
      // 確認用フラグ
      let checkFlg: boolean = <boolean>false;

      // 再度DataGrid分ループし、初期値以外のグループIDで、取得したグループIDと異なるものが存在しないか確認する
      for (const tempVO of this.kymw0600Model.relatedGoodsList) {
        if (tempVO.groupId >= 0 && tempVO.groupId !== checkGroupIdNum) {
          checkFlg = true;
          break;
        }
      }

      if (checkFlg) {
        // 更新確認メッセージを表示
        this.dialogService.openAlertGetMessage('Q0108', ['複数の関連商品'], 
          (closedEvent: number) => this.eventAlert1_CLICKHandler(closedEvent));
      } else {
        // サーバの更新イベントを発生させる
        this.saveEventDispatch();
      }
    } else {
      // サーバの更新イベントを発生させる
      this.saveEventDispatch();
    }

  }

  /**
   * 登録確認メッセージダイアログが閉じられたときに呼び出されるイベント
   * @param closeEvent コールバック・イベントへの参照
   *
   */
  public eventAlert1_CLICKHandler(closeEvent: number): void {
    // OKを押しているか確認
    if (closeEvent === PlessAlert.Yes) {
      // サーバへの更新イベントを発生させる
      this.saveEventDispatch();
    }
  }

  /**
   * 閉じるボタン押下時の処理
   */
  public eventBtnClose_CLICKHandler(): void {
    if (this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0110', [''],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes) {
            // ダイアログを閉じる
            super.onClickClose();
          }
        });
    } else {
      super.onClickClose();
    }
  }

  /**
   * 「更新」ボタン押下後のCommand(TextInfoRegist)から呼び出される
   * 選択でチェックされた文字情報の商品付随文字選択VOを作成し、呼出元画面へ返却する。
   *
   */
  public updateParent(): void {
    if (this.setKYMW0600Parameter != null) {
      this.setKYMW0600Parameter(this.createKYMW0600OutputVO());
    }
  }

  /**
   * KYMW0600OutputVOを生成し、呼出元に返す
   * @param なし
   * @return
   * 	親画面返却VO
   */
  public createKYMW0600OutputVO(): KYMW0600OutputModel {
    const returnVO: KYMW0600OutputModel = new KYMW0600OutputModel();

    this.kymw0600Model.relatedGoodsList.forEach((element, ind) => {
      if (ind == 0) {
        returnVO.relationPCodeNew = element.pCode;
      } else if (ind == 2) {
        returnVO.relationPCodeOld = element.pCode;
      }
    });

    return returnVO;
  }

  /**
   * コンテキストメニューの設定
   */
  public createContextMenu(): void {

    // 関連Pコード一覧
    this.relatedGoodsContextmenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: 'クリア', caption: 'クリア', cmd: 'clear',
            enabled: true
          },
        ],
        command: this.getFormatContextMenuCommand(),
        // イベント設定
        itemClicked: () => {
          // クリア処理
          this.eventDgRelatedInfoClear_CLICKHandler();
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dg_relatedInfo.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();

      // 非表示処理
      if (this.dg_relatedInfo.selectedItems.length == 1 &&
          PlessViewUtils.isEmpty(this.dg_relatedInfo.selectedItems[0].oldNew)) {
        return;
      }

      if (this.relatedGoodsContextmenu !== undefined) {
        this.relatedGoodsContextmenu.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.relatedGoodsContextmenu.itemsSource[0]);

    // 候補一覧
    this.candidateGoodsContextmenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: '新商品に設定', caption: '新商品に設定', cmd: 'newGoodsSetup',
            enabled: true
          },
          {
            header: '旧商品に設定', caption: '旧商品に設定', cmd: 'oldGoodsSetup',
            enabled: true
          },
        ],
        command: this.getFormatContextMenuCommand(),
        // イベント設定
        itemClicked: () => {
          switch (this.candidateGoodsContextmenu.selectedValue) {
            case 'newGoodsSetup':
              // 新商品設定
              this.eventDgCandidateInfoGoodsSetup_CLICKHandler(0);
              break;
            case 'oldGoodsSetup':
              // 旧商品設定
              this.eventDgCandidateInfoGoodsSetup_CLICKHandler(2);
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dg_candidateInfo.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.candidateGoodsContextmenu !== undefined) {

        // 非表示処理
        const targetPcode = this.kymw0600Model.relatedGoodsList[1].pCode;
        const selectPcode = this.dg_candidateInfo.selectedItems[0].pCode;
        if (targetPcode == selectPcode) {
          return;
        }

        this.candidateGoodsContextmenu.show(e);
      }
    });
  }


  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1100Component
   */
  private getFormatContextMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }
}

